import classNames from 'classnames'
import React from 'react'
import ReactMarkdown from 'react-markdown'

import { Icon } from 'browser/components/atomic-elements/atoms/icon/icon'
import {
  BannerMode,
  UI2BannerProps,
  UI2_BANNER_DEFAULT_PROPS,
} from 'shared-libs/components/ui2/display/ui2-banner/ui2-banner-props'
import { translateString } from 'shared-libs/helpers/utils'

import './_ui2-banner.scss'

const DEFAULT_ICONS: Record<BannerMode, string> = {
  success: 'tick-circle',
  info: 'info-sign',
  warning: 'warning-sign',
  danger: 'error',
  neutral: 'info-sign',
}

export const UI2Banner: React.FC<UI2BannerProps> = (props) => {
  const resolvedProps = { ...UI2_BANNER_DEFAULT_PROPS, ...props }
  const {
    text,
    markdownText,
    mode = 'neutral',
    title,
    icon,
    children,
    translationTable,
    frames,
  } = resolvedProps
  const iconName = icon ?? DEFAULT_ICONS[mode]
  const containerClass = classNames('ui2-banner', `ui2-banner--${mode}`)
  const resolvedTable = Object.assign({}, frames?.getContext('translationTable'), translationTable)
  const translatedTitle = title ? translateString(title, resolvedTable) ?? title : undefined
  const translatedMarkdown = markdownText
    ? translateString(markdownText, resolvedTable) ?? markdownText
    : undefined
  const translatedText = text ? translateString(text, resolvedTable) ?? text : undefined
  const body = translatedMarkdown ?? translatedText

  return (
    <div className={containerClass}>
      <div className="ui2-banner__header">
        <Icon name={iconName as any} size={16} />
        {translatedTitle && <span className="ui2-banner__title">{translatedTitle}</span>}
      </div>
      {body && (
        <div className="ui2-banner__body">
          {translatedMarkdown ? <ReactMarkdown>{body}</ReactMarkdown> : body}
        </div>
      )}
      {children && <div className="ui2-banner__actions">{children}</div>}
    </div>
  )
}
